import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import { route } from '@helpers'
import React from 'react'

export default function Member({ club }: Props) {
    return (
        <Grid gap="15px">
            <Grid gap="10px">
                <h1 className="h3">You're the member of the group</h1>
                <p>It's the invitation link for {club.name}. You're already a member of the group, you don't need an invitation. Please, click the button below to visit your group's profile.</p>
            </Grid>
            <Flex><Button width="auto" to={route("club:customer")}>Visit group</Button></Flex>
        </Grid>
    )
}

interface Props {
    club: Resources.ClubPartial
}